import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[productHover]',
    standalone: false
})
export class ProductHoverDirective {

  constructor(private _elRef: ElementRef, private _renderer: Renderer2) {
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    const productLib = this._elRef.nativeElement.querySelector('.down-arrow-div-container');
    const amountInput = this._elRef.nativeElement.querySelector('.amount-input');
    const lastAmountInput = this._elRef.nativeElement.querySelector('.last-input-amount');

    if (productLib) {
      this._renderer.removeClass(productLib, 'visibility-hidden');
    }

    if (lastAmountInput) {
      // amountInput.focus();
      if (!amountInput.value) {
        this._renderer.removeClass(productLib, 'amount-field-focus');
      }
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    const productLib = this._elRef.nativeElement.querySelector('.down-arrow-div-container');
    const amountField = this._elRef.nativeElement.querySelector('.amount-per-unit-container');
    const amountInput = this._elRef.nativeElement.querySelector('.amount-input');

    if (productLib) {
      this._renderer.addClass(productLib, 'visibility-hidden');
    }

    if (amountInput && amountInput.value) {
      const inputFieldHasError = amountField.querySelector('.amount-field-focus');
    }
  }

}
